import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  labelDpiLabel: {
    description: 'Label print options DPI label',
    defaultMessage: 'Label DPI',
    id: 'xGpJcx',
  },
  label300Dpi: {
    description: 'Label 300 DPI',
    defaultMessage: '300 DPI',
    id: 's4Heef',
  },
  label203Dpi: {
    description: 'Label 203 DPI',
    defaultMessage: '203 DPI',
    id: 'xkdDKn',
  },
  learnAboutLabelDpi: {
    description: 'Learn about label dpi link',
    defaultMessage: 'Learn about label DPI',
    id: 'HKby35',
  },
  labelDpiExplanationTitle: {
    description: 'label DPI explanation title',
    defaultMessage: 'What is Label DPI?',
    id: 'OaN+CJ',
  },
  labelDpiExplanationFirstParagraph: {
    description: 'label DPI explanation first paragraph',
    defaultMessage:
      'Label DPI (or "dots-per-inch") is the resolution at which you labels are printed. Some of the thermal printers or computing hardware you might use are calibrated to use a specific DPI for printing out labels. In most cases, you will never need to change away from 300 DPI (the default) since that is the current standard for printing high-quality images and labels from computer to physical.',
    id: '/LOaQ0',
  },
  labelDpiExplanationSecondParagraph: {
    description: 'label DPI explanation second paragraph',
    defaultMessage:
      'However, certain hardware configurations (for instance, a Zebra LP 2844 thermal printer that is set up to print from a Mac) need a different DPI — in this case, 203 DPI — where you will need to change this setting.',
    id: 'oMpVMR',
  },
  labelDpiExplanationThirdParagraph: {
    description: 'label DPI explanation third paragraph',
    defaultMessage:
      'All our articles on setting up printers include how to change this setting in their instructions, if such a change is necessary. If you have not been instructed by one of these articles to change it, leave it at 300 DPI.',
    id: 'QIAL+l',
  },
  labelDpiExplanationAcknowledgement: {
    description: 'label DPI explanation acknowledgement',
    defaultMessage: 'Got it thanks!',
    id: 'bvjbwm',
  },
  batchSummaryPageOptionLabel: {
    description: 'label batch summary page option label',
    defaultMessage: 'Batch Summary Page Option',
    id: 'kA5SJD',
  },
  batchSummaryPageOptionDescription: {
    description: 'label batch summary page option description',
    defaultMessage: 'Display batch information as a page in label batch',
    id: 'jeLExg',
  },
  batchSummaryNone: {
    description: 'label batch summary none',
    defaultMessage: 'No Summary (Default)',
    id: 'GEyfKR',
  },
  batchSummaryBeginning: {
    description: 'label batch summary at beginning',
    defaultMessage: 'Beginning of label batch',
    id: 'L6R3v4',
  },
  batchSummaryEnd: {
    description: 'label batch summary at end',
    defaultMessage: 'End of label batch',
    id: 'HueEDO',
  },
  orderLabelsBy: {
    description: 'label print settings label sorting',
    defaultMessage: 'Order Labels By',
    id: 'nM2tWj',
  },
  orderLabelsByNote: {
    description: 'label print settings label sorting note',
    defaultMessage: 'Note: This setting applies to the print order for <a>both</a> labels and packing slips.',
    id: 'SsiOg6',
  },
  orderLabelsByNone: {
    description: 'order labels by none option',
    defaultMessage: 'None (as selected)',
    id: 'uHob6D',
  },
  orderByOrderDateDesc: {
    description: 'order labels by order date descending',
    defaultMessage: 'Order Date: most recent first',
    id: 'ADW8M3',
  },
  orderByOrderDateAsc: {
    description: 'order labels by order date ascending',
    defaultMessage: 'Order Date: most recent last',
    id: 'CBf01v',
  },
  orderByPaidDateDesc: {
    description: 'order labels by paid date descending',
    defaultMessage: 'Paid Date: most recent first',
    id: 'jPo+i6',
  },
  orderByPaidDateAsc: {
    description: 'order labels by paid date ascending',
    defaultMessage: 'Paid Date: most recent last',
    id: 'tgyOpP',
  },
  orderByRecipientNameAsc: {
    description: 'order labels by recipient name ascending',
    defaultMessage: 'Recipient Name: a to z',
    id: 'DZXote',
  },
  orderByRecipientNameDesc: {
    description: 'order labels by recipient name descending',
    defaultMessage: 'Recipient Name: z to a',
    id: 'ucEPNG',
  },
  orderByOrderNumberAsc: {
    description: 'order labels by order number ascending',
    defaultMessage: 'Order Number: lowest first',
    id: '7E/6qD',
  },
  orderByOrderNumberDesc: {
    description: 'order labels by order number descending',
    defaultMessage: 'Order Number: highest first',
    id: 'RHfYTT',
  },
  orderByItemSkuAsc: {
    description: 'order labels by item sku ascending',
    defaultMessage: 'Item SKU: a to z',
    id: '/6fBw1',
  },
  orderByItemSkuDesc: {
    description: 'order labels by item sku descending',
    defaultMessage: 'Item Sku: z to a',
    id: 'uq+vtM',
  },
  orderByItemNameAsc: {
    description: 'order labels by item name ascending',
    defaultMessage: 'Item Name: a to z',
    id: '6HX+Mx',
  },
  orderByItemNameDesc: {
    description: 'order labels by item name descending',
    defaultMessage: 'Item Name: z to a',
    id: 'j24yOA',
  },
  orderByWarehouseLocationAsc: {
    description: 'order labels by warehouse location ascending',
    defaultMessage: 'Warehouse Location: a to z',
    id: 'xuDhZf',
  },
  orderByWarehouseLocationDesc: {
    description: 'order labels by warehouse location descending',
    defaultMessage: 'Warehouse Location: z to a',
    id: 'WXKiXz',
  },
  labelBranding: {
    description: 'label print settings label branding',
    defaultMessage: 'Label Branding',
    id: 'g2R9MN',
  },
  printStoreLogos: {
    description: 'label print settings include store logos',
    defaultMessage: 'Print my store logos on my shipping labels.',
    id: '+fxzXn',
  },
  labelMessages: {
    description: 'label print settings label messages',
    defaultMessage: 'Label Messages',
    id: 'keNMQP',
  },
  labelMessageDescription: {
    description: 'label print settings label messages description',
    defaultMessage:
      'Define up to 3 custom messages to print on your shipping label, including dynamic information about the order. <a>Each message is limited to 26 characters.</a>',
    id: 'PGtVkt',
  },
  message1: {
    description: 'label message 1',
    defaultMessage: 'Message #1',
    id: 'Xasn+8',
  },
  message2: {
    description: 'label message 2',
    defaultMessage: 'Message #2',
    id: 'ajdMsF',
  },
  message3: {
    description: 'label message 3',
    defaultMessage: 'Message #3',
    id: '9qzcQF',
  },
  orderNumber: {
    description: 'label message order number',
    defaultMessage: '[Order #]',
    id: 'cSRhiW',
  },
  storeCompanyName: {
    description: 'label message store company name',
    defaultMessage: '[Store Company Name]',
    id: 'AQky3S',
  },
  shipDate: {
    description: 'label message ship date',
    defaultMessage: '[Ship Date]',
    id: 'Yv9FA+',
  },
  orderDate: {
    description: 'label message order date',
    defaultMessage: '[Order Date]',
    id: 'CjdQ8U',
  },
  sku1: {
    description: 'label message sku 1',
    defaultMessage: '[Sku #1]',
    id: '4HZjNT',
  },
  sku2: {
    description: 'label message sku 2',
    defaultMessage: '[Sku #2]',
    id: '2TYUTu',
  },
  sku3: {
    description: 'label message sku 3',
    defaultMessage: '[Sku #3]',
    id: '7SkKqr',
  },
  product1: {
    description: 'label message product 1',
    defaultMessage: '[Product #1]',
    id: '1bBxw2',
  },
  product2: {
    description: 'label message product 2',
    defaultMessage: '[Product #2]',
    id: 'nF5Z+2',
  },
  product3: {
    description: 'label message product 3',
    defaultMessage: '[Product #3]',
    id: 'OQqgOf',
  },
  dimensions: {
    description: 'label message dimensions',
    defaultMessage: '[Dimensions]',
    id: 'CUT/ua',
  },
  weight: {
    description: 'label message weight',
    defaultMessage: '[Weight]',
    id: 'IFLWgl',
  },
  notesFromBuyer: {
    description: 'label message notes from buyer',
    defaultMessage: '[Notes from Buyer]',
    id: 'r+HnHM',
  },
  customField1: {
    description: 'label message custom field 1',
    defaultMessage: '[Custom Field #1]',
    id: 'lZcf9R',
  },
  customField2: {
    description: 'label message custom field 2',
    defaultMessage: '[Custom Field #2]',
    id: 'W8rhsh',
  },
  customField3: {
    description: 'label message custom field 3',
    defaultMessage: '[Custom Field #3]',
    id: 'Ba867N',
  },
  fillSku1: {
    description: 'label message fill sku 1',
    defaultMessage: '[Fill Sku #1]',
    id: 'vOPzGs',
  },
  fillSku2: {
    description: 'label message fill sku 2',
    defaultMessage: '[Fill Sku #2]',
    id: 'bplGWK',
  },
  fillSku3: {
    description: 'label message fill sku 3',
    defaultMessage: '[Fill Sku #3]',
    id: 'HGa7j4',
  },
  warehouse1: {
    description: 'label message warehouse location 1',
    defaultMessage: '[Warehouse Loc #1]',
    id: '2M/vnM',
  },
  warehouse2: {
    description: 'label message warehouse location 2',
    defaultMessage: '[Warehouse Loc #2]',
    id: '4g8KXm',
  },
  warehouse3: {
    description: 'label message warehouse location 3',
    defaultMessage: '[Warehouse Loc #3]',
    id: 'dPb4ut',
  },
  buyerName: {
    description: 'label message buyer name',
    defaultMessage: '[Buyer Name]',
    id: '1/b158',
  },
  pleaseSelect: {
    description: 'label message please select',
    defaultMessage: 'Please Select',
    id: 'FFrFLt',
  },
  shippingCutoff: {
    description: 'label print settings shipping cutoff',
    defaultMessage: 'Shipping Cutoff',
    id: 'zlyf9r',
  },
  shippingCutoffMessage: {
    description: 'label print settings shipping cutoff message',
    defaultMessage: 'Set the Ship Date to the next day if the time is after:',
    id: 'ensbgf',
  },
  preview: {
    description: 'label print settings preview button',
    defaultMessage: 'Preview',
    id: 'ji8k27',
  },
});
